import React, { useEffect } from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useResource from 'Hooks/useResource';
import ScheduleSendReview from 'Components/Modals/ScheduleSendReview';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  emailForm: {
    marginRight: theme.spacing(2),
    flexGrow: 1,
  },
});

const ReminderScheduleSendReview = ({
  reminderResource,
  ...rest
}) => {
  const { resource, setResourceDeprecated: setResource } = useResource();
  const { setHouseholdId } = useSimpleHousehold();

  useEffect(() => {
    if (!reminderResource) {
      return;
    }
    reminderResource.relationship(fr.relationships.meetingAgenda.name).link('related').get().then(meetingAgendaResponse => {
      const meetingAgendaResource = meetingAgendaResponse.resources().head();
      setResource(meetingAgendaResource);
      setHouseholdId(meetingAgendaResource.attr('householdId'));
    });
  }, []);


  if (!resource) {
    return null;
  }

  return (
    <ScheduleSendReview
      meetingAgendaResource={resource}
      {...rest}
    />
  );
};

ReminderScheduleSendReview.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  reminderResource: PropTypes.object.isRequired,
  refreshResources: PropTypes.func.isRequired,
};

export default withStyles(styles)(ReminderScheduleSendReview);
